var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isProfileLoaded)?_c('v-footer',{staticClass:"pa-3",attrs:{"color":"blue darken-1","dark":"","fixed":""}},[_c('v-layout',{staticClass:"justify-center"},[_c('span',{staticClass:"text-xs-center"},[_c('small',[_vm._v(" Copyright © 2025 All Rights Reserved by "),_c('br'),_vm._v("  Innotech Laboratory Service Co., Ltd.")])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }